var smallestValues = function (miles, unit) { return Math.floor(miles / unit) * unit; };
var largestValues = function (miles, unit) { return Math.ceil(miles / unit) * unit; };
var getMilesEitherSideOfEstimate = function (estimateMiles, calculatePrices) {
    if (estimateMiles === 1000)
        return [
            {
                estimateMiles: 900,
                estimateCost: calculatePrices(900),
            },
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: 2000,
                estimateCost: calculatePrices(2000),
            },
            {
                estimateMiles: 3000,
                estimateCost: calculatePrices(3000),
            },
        ];
    if (estimateMiles === 2000)
        return [
            {
                estimateMiles: 1000,
                estimateCost: calculatePrices(1000),
            },
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: 3000,
                estimateCost: calculatePrices(3000),
            },
            {
                estimateMiles: 4000,
                estimateCost: calculatePrices(4000),
            },
        ];
    // >= 2000 and is not a whole thousand
    if (estimateMiles >= 2000 && estimateMiles % 1000 > 0)
        return [
            {
                estimateMiles: smallestValues(estimateMiles, 1000) - 1000,
                estimateCost: calculatePrices(smallestValues(estimateMiles, 1000) - 1000),
            },
            {
                estimateMiles: smallestValues(estimateMiles, 1000),
                estimateCost: calculatePrices(smallestValues(estimateMiles, 1000)),
            },
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000),
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000)),
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 1000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 1000),
            },
        ];
    // > 2000 and is a whole thousand
    if (estimateMiles > 2000 && estimateMiles % 1000 === 0)
        return [
            {
                estimateMiles: smallestValues(estimateMiles, 1000) - 2000,
                estimateCost: calculatePrices(smallestValues(estimateMiles, 1000) - 2000),
            },
            {
                estimateMiles: smallestValues(estimateMiles, 1000) - 1000,
                estimateCost: calculatePrices(smallestValues(estimateMiles, 1000) - 1000),
            },
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 1000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 1000),
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 2000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 2000),
            },
        ];
    // HUNDREDS
    // > 300 and is not a whole hundred
    if (estimateMiles > 300 && estimateMiles % 100 > 0)
        return [
            {
                estimateMiles: smallestValues(estimateMiles, 100) - 200,
                estimateCost: calculatePrices(smallestValues(estimateMiles, 100) - 200),
            },
            {
                estimateMiles: smallestValues(estimateMiles, 100) - 100,
                estimateCost: calculatePrices(smallestValues(estimateMiles, 100) - 100),
            },
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000),
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000)),
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 1000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 1000),
            },
        ];
    // > 200 and is not a whole hundred
    if (estimateMiles > 200 && estimateMiles % 100 > 0)
        return [
            {
                estimateMiles: smallestValues(estimateMiles, 100) - 100,
                estimateCost: calculatePrices(smallestValues(estimateMiles, 100) - 100),
            },
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000),
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000)),
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 1000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 1000),
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 2000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 1000),
            },
        ];
    // > 100 and is not a whole hundred
    if (estimateMiles > 100 && estimateMiles % 100 > 0)
        return [
            {
                estimateMiles: estimateMiles - (estimateMiles % 100),
                estimateCost: calculatePrices(estimateMiles),
            },
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000),
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000)),
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 1000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 1000),
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 2000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 2000),
            },
        ];
    // > 100 and is a whole hundred
    if (estimateMiles > 100 && estimateMiles % 100 === 0)
        return [
            {
                estimateMiles: smallestValues(estimateMiles, 100) - 200,
                estimateCost: calculatePrices(smallestValues(estimateMiles, 100) - 200),
            },
            {
                estimateMiles: smallestValues(estimateMiles, 100) - 100,
                estimateCost: calculatePrices(smallestValues(estimateMiles, 100) - 100),
            },
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000),
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000)),
            },
            {
                estimateMiles: largestValues(estimateMiles, 1000) + 1000,
                estimateCost: calculatePrices(largestValues(estimateMiles, 1000) + 1000),
            },
        ];
    if (estimateMiles === 0 || estimateMiles === 100)
        return [
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: largestValues(estimateMiles, 10) + 100,
                estimateCost: calculatePrices(largestValues(estimateMiles, 10) + 100),
            },
            {
                estimateMiles: largestValues(estimateMiles, 10) + 200,
                estimateCost: calculatePrices(largestValues(estimateMiles, 10) + 200),
            },
            {
                estimateMiles: largestValues(estimateMiles, 10) + 300,
                estimateCost: calculatePrices(largestValues(estimateMiles, 10) + 300),
            },
            {
                estimateMiles: largestValues(estimateMiles, 10) + 400,
                estimateCost: calculatePrices(largestValues(estimateMiles, 10) + 400),
            },
        ];
    if (estimateMiles < 100)
        return [
            {
                estimateMiles: estimateMiles,
                estimateCost: calculatePrices(estimateMiles),
                active: true,
            },
            {
                estimateMiles: largestValues(estimateMiles, 100),
                estimateCost: calculatePrices(largestValues(estimateMiles, 100)),
            },
            {
                estimateMiles: largestValues(estimateMiles, 100) + 100,
                estimateCost: calculatePrices(largestValues(estimateMiles, 100) + 100),
            },
            {
                estimateMiles: largestValues(estimateMiles, 100) + 200,
                estimateCost: calculatePrices(largestValues(estimateMiles, 100) + 200),
            },
            {
                estimateMiles: largestValues(estimateMiles, 100) + 300,
                estimateCost: calculatePrices(largestValues(estimateMiles, 100) + 300),
            },
        ];
};
export var GetProjections = function (_a) {
    var estimateMiles = _a.estimateMiles, calculatePrices = _a.calculatePrices;
    return getMilesEitherSideOfEstimate(estimateMiles, calculatePrices) || [];
};
